import React, { forwardRef, useState } from 'react';
import { Input } from 'antd';
import { Controller } from 'react-hook-form';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';

const ThemeInput = forwardRef((props, _ref) => {
  const {
    name,
    control,
    errors,
    rules = {},
    label = '',
    labelClassName = '',
    placeholder = '',
    type = 'text',
    className = '',
    disabled = false,
    minLength = 0,
    maxLength = 255,
    prefix,
    autoComplete = 'on',
    ...rest
  } = props;

  // Password visibility supports BOTH modes: controlled (parent passes
  // showPassword + setShowPassword) and uncontrolled (fall back to internal
  // state). Without the fallback, a password field rendered without those props
  // crashes on eye-toggle (rest.setShowPassword is not a function).
  const [internalShowPassword, setInternalShowPassword] = useState(false);
  const isControlledPassword = typeof rest?.setShowPassword === 'function';
  const isPasswordVisible = isControlledPassword ? rest?.showPassword : internalShowPassword;
  const togglePassword = (visible) => {
    if (isControlledPassword) rest.setShowPassword(visible);
    else setInternalShowPassword(visible);
  };

  return (
    <>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field }) => (
          <div className="relative">
            <label
              className={`${label ? 'd-block' : 'd-none'} theme-label ${labelClassName}`}
              htmlFor={name}
            >
              {label}
            </label>
            <Input
              {...field}
              prefix={prefix}
              className={`theme-input ${className}`}
              placeholder={placeholder}
              disabled={disabled}
              value={field.value || ''}
              onChange={field.onChange}
              minLength={minLength}
              maxLength={maxLength}
              autoComplete={autoComplete}
              type={type == 'password' ? (isPasswordVisible ? 'text' : 'password') : type}
            />

            {type == 'password' && (
              <div className="password-eye">
                {isPasswordVisible ? (
                  <EyeOutlined className="text-black" onClick={() => togglePassword(false)} />
                ) : (
                  <EyeInvisibleOutlined
                    className="text-black"
                    onClick={() => togglePassword(true)}
                  />
                )}
              </div>
            )}
          </div>
        )}
      />
      {errors[name] && <span className="text-error">{errors[name].message}</span>}
    </>
  );
});

export default ThemeInput;
